import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import s from './Privacy.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Helmet } from 'react-helmet-async';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";

const breadcrumbs = [
  { label: 'ホーム', link: '/' },
  { label: '個人情報保護方針' }
];

const Privacy = () => {
  const breadcrumbItems = [
    { name: 'ホーム ', link: '/' },
    { name: '個人情報保護方針'}
  ];
  return (
      <>
        <Helmet>
          <title>個人情報保護方針</title>
          <meta property="og:title" content="個人情報保護方針" />
          <meta
              property="og:image"
              content={`${process.env.REACT_APP_URL}/og-image.png`}
          />
          <meta
              property="og:url"
              content={`${process.env.REACT_APP_URL}/privacy`}
          />
          <meta
              name="description"
              content="自社ツアーやオプショナルツアーも予約できます！"
          />
          <meta
              property="og:description"
              content="自社ツアーやオプショナルツアーも予約できます！"
          />
          <meta property="og:type" content="article" />
        </Helmet>

        <div className={s.root}>

          <div className={"row mt-3"}>
            <div className={"col-12"}>
              <Breadcrumb items={breadcrumbItems}/>
              <div className={s.titleContainer}>
                <h2><img className={s.titleImage} src={titleImage}/>個人情報保護方針</h2>
              </div>
            </div>
          </div>
          <div className="container py-5">
            <div className="row justify-content-center">
              <div className="col-lg-12">

                {/* Intro Card */}
                <div className="card shadow-sm border-0 rounded-4 mb-4">
                  <div className="card-body p-4 p-md-5">
                    <p className="mb-0 fs-6 lh-lg text-secondary">
                      JAY&amp;JAY PTY LTDが運営するWebサイト
                      「ジェイさんの安心で楽しい日本語ツアー」
                      （以下、「本Webサイト」という）では、
                      個人情報の保護に関する法令およびその他の規範を遵守し、
                      個人情報の保護に最大限の注意を払います。
                      <br /><br />
                      本Webサイトでは、個人情報保護方針に基づき、
                      個人情報の取り扱いについて以下の通り定め、
                      本サイトの運営を行います。
                    </p>
                  </div>
                </div>

                {/* Section 1 */}
                <div className="card shadow-sm border-0 rounded-4 mb-4">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="mb-3 text-primary">情報の収集について</h3>
                    <p className="lh-lg text-secondary">
                      本Webサイトでは、サービスをご利用いただく際、
                      個人情報のご記入をお願いしております。
                      ご記入して頂いた個人情報は、
                      その収集目的以外で利用することは一切ありません。
                    </p>
                  </div>
                </div>

                {/* Section 2 */}
                <div className="card shadow-sm border-0 rounded-4 mb-4">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="mb-3 text-primary">情報収集の目的</h3>
                    <p className="lh-lg text-secondary">
                      本Webサイトでは、
                      「ツアーの予約、手配およびこれに付随する業務の目的」
                      で個人情報を収集致します。
                    </p>
                  </div>
                </div>

                {/* Section 3 */}
                <div className="card shadow-sm border-0 rounded-4 mb-4">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="mb-3 text-primary">情報の安全性</h3>
                    <p className="lh-lg text-secondary">
                      インターネット上で安全に個人情報を送受信しています。
                      また個人情報を取り扱う管理責任者を配置し、
                      個人情報の取り扱いに関する規定を設け、
                      外部に情報が漏れることが無いように管理しています。
                    </p>
                  </div>
                </div>

                {/* Section 4 */}
                <div className="card shadow-sm border-0 rounded-4 mb-4">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="mb-3 text-primary">情報の共有・開示</h3>

                    <p className="lh-lg text-secondary">
                      本Webサイトがお客様から収集させて頂いた個人情報は、
                      以下の場合を除き、
                      第三者に提供・開示等を一切致しません。
                    </p>

                    <ul className="text-secondary lh-lg">
                      <li>収集した情報が参加予約の内容と異なる場合</li>
                      <li>法令等により開示・提供が求められた場合</li>
                    </ul>

                    <p className="lh-lg text-secondary mt-3">
                      個人情報は、利用目的の達成に必要な範囲で、
                      正確かつ最新の状態で管理致します。
                      また、お客様が個人情報に関して照会、
                      修正、削除等をご希望される場合には、
                      適切に対応させて頂きます。
                    </p>
                  </div>
                </div>

                {/* Section 5 */}
                <div className="card shadow-sm border-0 rounded-4 mb-4">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="mb-3 text-primary">本方針について</h3>

                    <p className="lh-lg text-secondary">
                      本Webサイトは、
                      個人情報の保護及び取り扱いの継続的な改善に努め、
                      本方針を適宜改訂致します。
                      また法令に変更があった場合も、
                      本方針の内容を改訂することがあります。
                    </p>

                    <p className="lh-lg text-secondary">
                      本方針の重要な変更がある場合は、
                      適切な方法で通知致します。
                    </p>

                    <div className="alert alert-light border mt-4">
                      JAY&amp;JAY PTY LTD
                      「ジェイさんの安心で楽しい日本語ツアー」の
                      個人情報に関するお問い合わせは
                      <a href="/contact" className="ms-1">
                        こちら
                      </a>
                      です。
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default Privacy;